import React from 'react';
import styled from 'styled-components';
import { Button, Icon } from 'fpay-ui';
import { Link } from 'react-router-dom';
import { USERS } from '@constants/routes';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const LinkContainer = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Link data-testid="redir-button-container" to={USERS}>
        <Button type="link" data-testid="redir-button">
          {t('users.title')}
        </Button>
        <Icon icon="ic_curve_arrow" width="13.1px" height="13.1px" />
      </Link>
    </Container>
  );
};

export default LinkContainer;
